// 默认半身头像
let defaultHalfPortrait = 'https://static001-test.geekbang.org/resource/image/22/ae/22f24eb47c5af8ef204f38ddb17c91ae.jpg'

export {
  defaultHalfPortrait
}
